<mat-toolbar color="accent">
	<mat-toolbar-row>
		<span>Enter Visit Details</span>
		<span class="spacer"></span>
		<span>
			<button type="button" aria-label="Go Back" mat-raised-button (click)="handleBack()">
				<mat-icon>chevron_left</mat-icon>
			</button>
		</span>
	</mat-toolbar-row>
</mat-toolbar>

<app-patient-visit-form 
	(onSubmit)="handleSubmit( $event )" 
	[canComplete]='true'
	[visits]="visits"
	[providers]="physicians"
	[provider]="physician"
	[previousVisitCptCodes]="previousVisitCptCodes"
	[previousVisitIcdCodes]="previousVisitIcdCodes"
	[allCptCodes]="allCptCodes" 
	[allIcdCodes]="allIcdCodes">
</app-patient-visit-form>
